var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"cmp-video-dialog",attrs:{"title":_vm.title,"visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.closePlay}},[_c('videoPlayer',{staticClass:"video-box",attrs:{"video-url":_vm.videoUrl,"videoId":_vm.videoId,"state":!_vm.dialogVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }